/**
 * Created by jahidul.hasan on 10/17/2020.
 */
import {EventEmitter, Injectable, OnDestroy, OnInit} from '@angular/core';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {Subject} from 'rxjs';
import {CommandService} from '@core/services/command.service';
import {ActivatedRoute, Router} from '@angular/router';
import {DialogService} from '@shared/services/dialog-service';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {PlatformCommand} from '@shared/commands/command-base';
import {take, takeUntil} from 'rxjs/operators';
import {DialogModel} from '@shared/models/dialog.model';
import {TranslationService} from './translation.service';
import {TranslationConfig} from '../translation-config';
import {QueryProvider} from '@shared/queries/query-provider';
import {select, Store} from '@ngrx/store';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {TranslationFormModel, TranslationModel, UpdateTranslationSettingsModel} from '../models/translation.model';
import {
  StorageSettings, TranslationFileTypes, TranslationStatus,
  TranslationToolNames
} from '../models/translation.constants';
import {SnackBarService} from '@core/services/snack-bar.service';
import {TaskManagerService} from '../../task-manager/services/task-manager.service';
import {getNotification} from '@shared/store/toast/toast-selectors';
import {IToastState} from '@shared/store/toast/toast-reducer';
import {FileManagementService} from '@core/services/file-management.service';
@Injectable({
  providedIn: 'root',
})
export class TranslationViewHandler implements IPlatformToolHandler {
  magicLinkModelValueChanged: EventEmitter<any> = new EventEmitter();
  magicLinkModel: MagicLinkModel;
  private selectedTabModel: TabModel;
  ngUnsubscribe = new Subject<void>();
  private translationModel: TranslationModel = new TranslationModel();
  private translationId: string;

  constructor(private commandService: CommandService,
              private translationService: TranslationService,
              private router: Router,
              private dialogService: DialogService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private taskManagerService: TaskManagerService,
              protected fileManagementService: FileManagementService,
              private snackBarService: SnackBarService) {
  }
  invalidateSubject: InvalidateSubject;
  executeCommand(command: PlatformCommand) {
    switch (command.name) {
      case 'TranslationSettingsCommand':
        this.onUpdateTranslationSetting(command);
        break;
      case 'DownloadFormCommand':
      case 'TranslationTaskCommand':
        this.openTask(command);
        break;
      case 'DownloadHtmlAsPdfCommand':
        this.downloadHtmlAsPdf(command);
        break;
      case 'DoneComparingCommand':
        this.doneComparing(command);
        break;
      case 'TranslateFormCommand':
      case 'FxRateCommand':
      case 'FixSpacingCommand':
      case 'ResetCommand':
        this.magicLinkModelValueChangedHandler({name: command.name, command: command});
        break;
      default:
         this.executeCommandToApi(command);
        break;
    }
  }

  private executeCommandToApi(command: PlatformCommand) {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          console.log('Command Response', commandResponse);
          this.fuseSplashScreenService.hide();
          if (commandResponse.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
          } else if (commandResponse.fieldValues['PlatformLinkModel']) {
            this.magicLinkModelValueChangedHandler({id: 'PlatformToolContainerComponent', value: commandResponse.fieldValues['PlatformLinkModel']});
          } else if (commandResponse.fieldValues['DownloadUrl']) {
            this.downloadTranslatedFile(commandResponse.fieldValues['DownloadUrl'], commandResponse.fieldValues['FileName']);
          }
        },
        error => {
          console.error('Failed ToolBarComponent command', error);
          this.fuseSplashScreenService.hide();
        });
    }
  }

  valueChanged($event) {
    console.log('Inside Handler', $event);
    if (this.handleAction($event)) {
      return;
    }
    if (this.handleCommand($event)) {
      return;
    }
    if ($event.item && $event.fieldDefinition && $event.fieldSection) {
      //
    }
  }

  private handleCommand($event): boolean {
    if ($event.command) {
      switch ($event.command.name) {
        default:
          this.executeCommand($event.command);
          return true;
      }
    }
    return false;
  }

  private handleAction($event): boolean {
    if (this.selectedTabModel && $event.action) {
      switch ($event.action.id) {
        case 'SaveTranslationModel':
          console.log('saving translation model:', $event.item);
          this.saveTranslationModel($event.item);
          return true;
      }
    }
    return false;
  }

  setSelectedTab(selectedTab: TabModel): void {
    this.selectedTabModel = selectedTab;
    if (this.selectedTabModel && this.selectedTabModel.tabData && this.selectedTabModel.tabData.TranslationId) {
      this.translationId = this.selectedTabModel.tabData.TranslationId;
    }
  }

  destroy() {
    this.invalidateSubject.close();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private onUpdateTranslationSetting(command: PlatformCommand) {
    this.getTranslationId();
    if (this.translationId) {
      if (!this.translationModel || this.translationModel.id !== this.translationId || this.translationModel.leftFile.fileType !== TranslationFileTypes.Pdf) {
        this.fuseSplashScreenService.show();
        this.translationService.getTranslatinModel(this.translationId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(translationModel => {
          this.fuseSplashScreenService.hide();
          if (translationModel && translationModel.id === this.translationId) {
            this.saveTranslationModel(translationModel);
            this.requestReTranslate(command);
          }
        }, err => {
          this.fuseSplashScreenService.hide();
          this.snackBarService.showError('Translation model fetching failed!!');
        });
      } else {
        this.requestReTranslate(command);
      }
    } else {
      this.snackBarService.showError('Translation Id not found!!!');
    }
  }



  private translationConfigDirty(config1: UpdateTranslationSettingsModel, tm: TranslationModel) {
    return config1.fileOneLanguage !== tm.leftFile.language
    || config1.fileTwoLanguage != tm.rightFile.language;
  }

  private magicLinkModelValueChangedHandler(command: any) {
    this.magicLinkModelValueChanged.emit(command);
  }

  private openTask(command: PlatformCommand) {
    this.taskManagerService.openTaskByTaskId(command.fieldValues['TicketDisplayId'], 'COMPANY').pipe(takeUntil(this.ngUnsubscribe)).subscribe(state => {
      console.log('task closed:', state, this.translationModel);
      this.checkForCleanUpTranslation();
    });
  }

  private saveTranslationModel(item: TranslationModel) {
    if (item) {
      this.translationModel = JSON.parse(JSON.stringify(item));
    }
  }



  private doneComparing(command: PlatformCommand) {
    if (command.fieldValues['RedirectUrl']) {
      this.router.navigateByUrl(command.fieldValues['RedirectUrl']);
    }
  }

  private getTranslationId() {
    this.translationId = this.magicLinkModel.id;
  }

  private requestReTranslate(command: PlatformCommand) {
    const translationConfig = new UpdateTranslationSettingsModel();
    translationConfig.toolName = this.translationModel.toolName;
    translationConfig.fileOneLanguage = this.translationModel.leftFile.language;
    translationConfig.fileOneName = this.translationModel.leftFile.fileName;
    translationConfig.isFileOneScanned = this.translationModel.leftFile.isScanned;
    translationConfig.fileTwoName = this.translationModel.rightFile.fileName;
    translationConfig.fileTwoLanguage = this.translationModel.rightFile.language;
    translationConfig.isFileTwoScanned = this.translationModel.rightFile.isScanned;
    translationConfig.status = this.translationModel.status;
    const dialogModel: DialogModel = DialogModel.create(
      this.translationModel.toolName,
      'UpdateTranslationSettingComponent', {translationConfig: translationConfig},
      '600px',
      '700px'
    );
    dialogModel.okCaption = 'Translate';

    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      console.log(res);
      if (res && res.action === 'OK') {
        if (this.translationConfigDirty(res.data.input.translationConfig, this.translationModel)) {
          const formConfig = res.data.input.translationConfig;
          if (this.translationModel.leftFile.fileType === TranslationFileTypes.Pdf) {
            this.magicLinkModelValueChangedHandler({name: command.name, formConfig: {formLangugage: formConfig.fileOneLanguage, toLanguage: formConfig.fileTwoLanguage}});
          } else {
            this.translationService.requestTranslation(this.translationId, this.translationModel.leftFile.fileId, formConfig.fileOneLanguage, formConfig.fileTwoLanguage).pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(response => {
                if (response) {
                  this.fetchTranslationModel(this.translationId);
                }
              });
          }
        } else {
          this.snackBarService.showInformation('No language changes found!!!');
        }
      }
    });
  }

  private fetchTranslationModel(translationId: string) {
    this.translationService.getTranslatinModel(translationId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(translationModel => {
      this.fuseSplashScreenService.hide();
      if (translationModel && translationModel.id === this.translationId) {
        this.saveTranslationModel(translationModel);
      }
    });
  }

  private cleanUpTranslationModel() {
    console.log('translation model:', this.translationModel, this.magicLinkModel);
    if (this.translationModel && this.translationModel.id === this.translationId && this.translationModel.storageSettings === StorageSettings.NonStored) {
      const prettifiedToolName = this.translationService.getPretifiedToolName(this.translationModel.toolName).toLowerCase();
      this.dialogService.showYesNoDialog('Clean up', `Do you want to clean up all the data associated with this ${prettifiedToolName}? Your ${prettifiedToolName} will be expired.`).subscribe(s1 => {
        if (s1.action === 'OK') {
           this.executeCommandToApi(this.magicLinkModel.cleanUpCommand);
        }
      });
    }
  }

  private checkForCleanUpTranslation() {
    this.getTranslationId();
    if (this.translationId) {
      if (!this.translationModel || this.translationModel.id !== this.translationId || this.translationModel.leftFile.fileType !== TranslationFileTypes.Pdf) {
        this.fuseSplashScreenService.show();
        this.translationService.getTranslatinModel(this.translationId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(translationModel => {
          this.fuseSplashScreenService.hide();
          if (translationModel && translationModel.id === this.translationId) {
            this.saveTranslationModel(translationModel);
            this.cleanUpTranslationModel();
          }
        }, err => {
          this.fuseSplashScreenService.hide();
          this.snackBarService.showError('Translation model fetching failed!!');
        });
      } else {
        this.cleanUpTranslationModel();
      }
    } else {
      this.snackBarService.showError('Translation Id not found!!!');
    }
  }

  private downloadAttachmentByTaskIdCommand(command: PlatformCommand) {

  }

  private downloadTranslatedFile(downloadUrl: string, fileName: string) {
    this.fileManagementService.downloadOneTimeSignedUrl(downloadUrl, fileName);
  }

  private downloadHtmlAsPdf(downloadHtmlAsPdfCommand: PlatformCommand) {
    this.magicLinkModelValueChangedHandler({name: downloadHtmlAsPdfCommand.name, command: downloadHtmlAsPdfCommand});
  }
}


